import LegalHeader from "@/components/LegalHeader";
import Footer from "@/components/Footer";

const TerminiCondizioni = () => {
  return (
    <div className="min-h-screen bg-background">
      <LegalHeader />
      <main className="pt-20 pb-16">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-primary mb-4">
                Termini e Condizioni
              </h1>
              <p className="text-muted-foreground">
                Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}
              </p>
            </div>

            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">1. Informazioni Generali</h2>
                <p>
                  <strong>DA ARMANDO S.R.L.</strong><br />
                  Sede legale: Via Aganoor Pompili, 25 — 06065 Passignano sul Trasimeno (PG)<br />
                  P.IVA / C.F. e n. iscr. Registro Imprese: 03963890540<br />
                  REA: PG-368050<br />
                  Capitale sociale: € 4.800,00 i.v.<br />
                  Amministratrice Unica: Mulla Xhirela<br />
                  PEC: daarmando@pec.it<br />
                  Tel: +39 075 388 0397
                </p>
                <p className="mt-4">
                  Questi Termini e Condizioni regolano l'utilizzo del sito web e dei servizi offerti da DA ARMANDO S.R.L. (Ristorante Da Armando).
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">2. Accettazione dei Termini</h2>
                <p>
                  L'utilizzo del sito web e dei servizi implica l'accettazione completa e incondizionata di questi Termini e Condizioni. 
                  Se non accetta questi termini, si prega di non utilizzare il sito.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">3. Servizi Offerti</h2>
                <p>Il sito web offre i seguenti servizi:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Visualizzazione del menu del ristorante</li>
                  <li>Sistema di prenotazione online</li>
                  <li>Informazioni sui servizi e la location</li>
                  <li>Galleria fotografica</li>
                  <li>Contatti e informazioni di apertura</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">4. Prenotazioni Online</h2>
                
                <h3 className="text-xl font-semibold text-primary mb-3">4.1 Processo di Prenotazione</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Le prenotazioni possono essere effettuate tramite il form online</li>
                  <li>È necessario fornire dati personali completi e veritieri</li>
                  <li>La prenotazione è confermata solo dopo la nostra conferma</li>
                  <li>Ci riserviamo il diritto di rifiutare prenotazioni per motivi organizzativi</li>
                </ul>

                <h3 className="text-xl font-semibold text-primary mb-3 mt-6">4.2 Cancellazione e Modifiche</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Le cancellazioni devono essere comunicate con almeno 24 ore di anticipo</li>
                  <li>Modifiche alla prenotazione sono possibili previo accordo</li>
                  <li>In caso di mancata presentazione senza preavviso, potremmo applicare restrizioni per future prenotazioni</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">5. Utilizzo del Sito</h2>
                <p>L'utente si impegna a:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Utilizzare il sito in modo lecito e rispettoso</li>
                  <li>Non diffamare o danneggiare la reputazione del ristorante</li>
                  <li>Non tentare di accedere a aree riservate senza autorizzazione</li>
                  <li>Non utilizzare il sito per scopi commerciali non autorizzati</li>
                  <li>Rispettare i diritti di proprietà intellettuale</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">6. Proprietà Intellettuale</h2>
                <p>
                  Tutti i contenuti del sito (testi, immagini, loghi, design) sono protetti da diritti d'autore e appartengono al Ristorante Da Armando. 
                  È vietata la riproduzione, distribuzione o modifica senza autorizzazione scritta.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">7. Limitazione di Responsabilità</h2>
                <p>
                  Il Ristorante Da Armando non si assume responsabilità per:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Interruzioni del servizio dovute a cause tecniche</li>
                  <li>Danni indiretti derivanti dall'utilizzo del sito</li>
                  <li>Contenuti di siti terzi linkati dal nostro sito</li>
                  <li>Errori di trasmissione dati</li>
                  <li>Utilizzo improprio del sito da parte degli utenti</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">8. Privacy e Sicurezza</h2>
                <p>
                  La gestione dei dati personali è regolata dalla nostra Privacy Policy. 
                  Adottiamo misure di sicurezza appropriate per proteggere i dati degli utenti.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">9. Modifiche ai Termini</h2>
                <p>
                  Ci riserviamo il diritto di modificare questi Termini e Condizioni in qualsiasi momento. 
                  Le modifiche saranno pubblicate su questa pagina e saranno efficaci dalla data di pubblicazione.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">10. Legge Applicabile</h2>
                <p>
                  Questi Termini e Condizioni sono regolati dalla legge italiana. 
                  Eventuali controversie saranno risolte dal Tribunale competente di Perugia.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">11. Contatti</h2>
                <p>Per domande sui Termini e Condizioni, può contattarci:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Email: Mullaxhirela@gmail.com</li>
                  <li>Telefono: +39 075 388 0397</li>
                  <li>Posta: Via Aganoor Pompili, 25, 06065 Passignano sul Trasimeno (PG)</li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TerminiCondizioni; 